import { CALL_API } from 'middleware/api';
import { CREDIT_SCORE_START_REGISTRATION_REQUEST, CREDIT_SCORE_START_REGISTRATION_SUCCESS, CREDIT_SCORE_START_REGISTRATION_FAILURE, CREDIT_SCORE_GET_SCORE_REQUEST, CREDIT_SCORE_GET_SCORE_SUCCESS, CREDIT_SCORE_GET_SCORE_FAILURE, CREDIT_SCORE_GET_ENHANCED_FACTORS_REQUEST, CREDIT_SCORE_GET_ENHANCED_FACTORS_SUCCESS, CREDIT_SCORE_GET_ENHANCED_FACTORS_FAILURE, CREDIT_SCORE_GET_REPORT_REQUEST, CREDIT_SCORE_GET_REPORT_SUCCESS, CREDIT_SCORE_GET_REPORT_FAILURE, CREDIT_SCORE_GET_REGISTRATION_STATUS_REQUEST, CREDIT_SCORE_GET_REGISTRATION_STATUS_SUCCESS, CREDIT_SCORE_GET_REGISTRATION_STATUS_FAILURE, CREDIT_SCORE_REQUEST_FETCH_FLOW, CREDIT_SCORE_RESET_DATA, CREDIT_SCORE_SET_PENDING_CONNECTION_REFETCH, CREDIT_SCORE_SET_REGISTRATION_COOLDOWN, CREDIT_SCORE_CLEAR_REGISTRATION_COOLDOWN, CREDIT_SCORE_MARK_ANIMATION_CONSUMED, CREDIT_SCORE_GET_DISPUTE_TOKEN_REQUEST, CREDIT_SCORE_GET_DISPUTE_TOKEN_SUCCESS, CREDIT_SCORE_GET_DISPUTE_TOKEN_FAILURE, CREDIT_SCORE_GET_ALERTS_REQUEST, CREDIT_SCORE_GET_ALERTS_SUCCESS, CREDIT_SCORE_GET_ALERTS_FAILURE, CREDIT_SCORE_MARK_ALERTS_READ_REQUEST, CREDIT_SCORE_MARK_ALERTS_READ_SUCCESS, CREDIT_SCORE_MARK_ALERTS_READ_FAILURE, CREDIT_SCORE_GET_HISTORY_REQUEST, CREDIT_SCORE_GET_HISTORY_SUCCESS, CREDIT_SCORE_GET_HISTORY_FAILURE, } from './types';
const BASE_URL = '/credit-score';
const AGENCY = 'transunion';
export const startCreditScoreRegistration = (body, agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/registration`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        muteAlertForStatuses: [409, 429],
        types: [
            CREDIT_SCORE_START_REGISTRATION_REQUEST,
            CREDIT_SCORE_START_REGISTRATION_SUCCESS,
            CREDIT_SCORE_START_REGISTRATION_FAILURE,
        ],
    },
});
export const getCreditScore = (agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/score`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            CREDIT_SCORE_GET_SCORE_REQUEST,
            CREDIT_SCORE_GET_SCORE_SUCCESS,
            CREDIT_SCORE_GET_SCORE_FAILURE,
        ],
    },
});
export const getEnhancedFactors = (agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/factors`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            CREDIT_SCORE_GET_ENHANCED_FACTORS_REQUEST,
            CREDIT_SCORE_GET_ENHANCED_FACTORS_SUCCESS,
            CREDIT_SCORE_GET_ENHANCED_FACTORS_FAILURE,
        ],
    },
});
export const getCreditReport = ({ includeConnectionStatus, includeSwitchSuggestion, includeRecurringPayments, isConnectionReconcile, } = {}, agency = AGENCY) => {
    const params = new URLSearchParams();
    if (includeConnectionStatus)
        params.set('includeConnectionStatus', 'true');
    if (includeSwitchSuggestion)
        params.set('includeSwitchSuggestion', 'true');
    if (includeRecurringPayments)
        params.set('includeRecurringPayments', 'true');
    const query = params.toString();
    return {
        [CALL_API]: {
            endpoint: `${BASE_URL}/${agency}/report${query ? `?${query}` : ''}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            ...(isConnectionReconcile ? { extra: { isConnectionReconcile } } : {}),
            types: [
                CREDIT_SCORE_GET_REPORT_REQUEST,
                CREDIT_SCORE_GET_REPORT_SUCCESS,
                CREDIT_SCORE_GET_REPORT_FAILURE,
            ],
        },
    };
};
export const getCreditScoreRegistrationStatus = (agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/registration`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            CREDIT_SCORE_GET_REGISTRATION_STATUS_REQUEST,
            CREDIT_SCORE_GET_REGISTRATION_STATUS_SUCCESS,
            CREDIT_SCORE_GET_REGISTRATION_STATUS_FAILURE,
        ],
    },
});
export const requestCreditScoreFetchFlow = (payload = {}) => ({
    type: CREDIT_SCORE_REQUEST_FETCH_FLOW,
    payload,
});
export const resetCreditScoreData = () => ({
    type: CREDIT_SCORE_RESET_DATA,
});
export const setPendingConnectionRefetch = () => ({
    type: CREDIT_SCORE_SET_PENDING_CONNECTION_REFETCH,
});
export const setCreditScoreRegistrationCooldown = (payload) => ({
    type: CREDIT_SCORE_SET_REGISTRATION_COOLDOWN,
    payload,
});
export const clearCreditScoreRegistrationCooldown = () => ({
    type: CREDIT_SCORE_CLEAR_REGISTRATION_COOLDOWN,
});
export const markCreditScoreAnimationConsumed = () => ({
    type: CREDIT_SCORE_MARK_ANIMATION_CONSUMED,
});
export const getDisputeToken = (agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/dispute-token`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        muteAlert: true,
        types: [
            CREDIT_SCORE_GET_DISPUTE_TOKEN_REQUEST,
            CREDIT_SCORE_GET_DISPUTE_TOKEN_SUCCESS,
            CREDIT_SCORE_GET_DISPUTE_TOKEN_FAILURE,
        ],
    },
});
export const getCreditAlerts = (agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/alerts`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            CREDIT_SCORE_GET_ALERTS_REQUEST,
            CREDIT_SCORE_GET_ALERTS_SUCCESS,
            CREDIT_SCORE_GET_ALERTS_FAILURE,
        ],
    },
});
export const markCreditAlertsAsRead = (alertIds = [], agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/alerts/read`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ alertIds }),
        extra: { alertIds },
        muteAlert: true,
        types: [
            CREDIT_SCORE_MARK_ALERTS_READ_REQUEST,
            CREDIT_SCORE_MARK_ALERTS_READ_SUCCESS,
            CREDIT_SCORE_MARK_ALERTS_READ_FAILURE,
        ],
    },
});
export const getCreditScoreHistory = (agency = AGENCY) => ({
    [CALL_API]: {
        endpoint: `${BASE_URL}/${agency}/score/history`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            CREDIT_SCORE_GET_HISTORY_REQUEST,
            CREDIT_SCORE_GET_HISTORY_SUCCESS,
            CREDIT_SCORE_GET_HISTORY_FAILURE,
        ],
    },
});
